import {useCallback, useState} from 'react'

const useToggle = (defaultValue: boolean | (() => boolean) = false): [boolean, () => void] => {
  const [enabled, setEnabled] = useState(defaultValue)
  const toggle = useCallback(() => {
    setEnabled(!enabled)
  }, [enabled])
  return [enabled, toggle]
}

export default useToggle
